import { BreadTransaction, BreadBudget } from "breadcommon";
import dayjs from "dayjs";

export function getFractionOfTimeIntoBudget(
  budget: BreadBudget,
  now: dayjs.Dayjs = dayjs(),
) {
  const millisFullBudgetDuration =
    budget.endDateTimestampSecs.valueOf() -
    budget.beginDateTimestampSecs.valueOf();

  const millisIntoBudget = Math.min(
    Math.max(now.valueOf() - budget.beginDateTimestampSecs.valueOf(), 0),
    millisFullBudgetDuration,
  );

  return millisIntoBudget / millisFullBudgetDuration;
}

export function getTransactionsToDate(
  filteredTransactions: BreadTransaction[],
  budget: BreadBudget,
): BreadTransaction[] {
  return filteredTransactions.filter(
    (transaction) =>
      transaction.date >= budget.beginDateTimestampSecs &&
      transaction.date <= budget.endDateTimestampSecs,
  );
}

export function getMonthlyTransactions(
  filteredTransactions: BreadTransaction[],
  budget: BreadBudget,
) {
  return calculateMonthly(budget, (startOfMonth) =>
    filterTransactionsToMonth(filteredTransactions, startOfMonth),
  );
}

export function getMonthlyTotals(
  monthlyTransactions: BreadTransaction[][],
): number[] {
  return monthlyTransactions.map((transactions) =>
    sumTransactions(transactions),
  );
}

export function calculateMonthly<T>(
  budget: BreadBudget,
  action: (startOfMonth: dayjs.Dayjs) => T,
): T[] {
  const calculations: T[] = [];
  for (
    let d = budget.beginDateTimestampSecs.startOf("month");
    d < budget.endDateTimestampSecs;
    d = d.add(1, "month")
  ) {
    calculations.push(action(d));
  }
  return calculations;
}

export function sumTransactions(transactions: BreadTransaction[]): number {
  return transactions.reduce((acc, transaction) => acc + transaction.amount, 0);
}

export function filterTransactionsToMonth(
  transactions: BreadTransaction[],
  month: dayjs.Dayjs,
): BreadTransaction[] {
  return transactions.filter(
    (transaction) =>
      transaction.date >= month.startOf("month") &&
      transaction.date <= month.endOf("month"),
  );
}
